import React from 'react';
import { useModal } from 'react-modal-hook';
import classnames from 'classnames';

import useWindowYOffset from '../hooks/useWindowYOffset';
import Button from './Button';
import ContactForm from './ContactForm';
import LogoSVG from '../svg/logo.svg';
import Modal from './Modal';

function HeaderMinimal({ isDark = false }) {
  const { isFirstRender, isYScrolled } = useWindowYOffset();

  const buttonTitle = 'Contact Sales';

  const [showModal, hideModal] = useModal(() => (
    <Modal closeHandler={hideModal} titleText={buttonTitle}>
      <ContactForm />
    </Modal>
  ));

  const wrapperClass = classnames('fixed top-0 z-50 w-full py-4', {
    'bg-transparent': !isYScrolled,
    'bg-white shadow-2xl bg-opacity-100':
      !isDark && isYScrolled,
    'bg-haiti shadow-2xl bg-opacity-100':
      isDark && isYScrolled,
      "transition duration-300": !isFirstRender,
  });

  const buttonColor = isDark ? 'white' : 'pink';

  return (
    <React.Fragment>
      <div className={wrapperClass}>
        <ul className="flex flex-row items-center max-w-6xl px-6 justify-between lg:mx-auto">
          <li>
            <span className="sr-only">GraphCMS</span>
            <LogoSVG
              className="h-8 lg:h-11"
              style={isDark ? { fill: 'white' } : { fill: 'currentColor' }}
            />
          </li>
          <li className="ignore-opacity">
            <Button colour={buttonColor} size="small" onClick={showModal}>
              {buttonTitle}
            </Button>
          </li>
        </ul>
      </div>
    </React.Fragment>
  );
}

export default HeaderMinimal;
